import { createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../shared/utils/api.js'

// Existing actions...
export const fetchAllSurveys = createAsyncThunk('surveys/fetchAllSurveys',
    async (params = {}, { rejectWithValue }) => {
        try {
          const queryString = new URLSearchParams(params).toString()
          const url = `/v1/surveys/all${queryString ? `?${queryString}` : ''}`
                     
          const response = await api.get(url)
          return response.data
        } catch (error) {
          return rejectWithValue(error.response?.data?.message || error.message)
        }
      }
)

export const updateSurveyStatus = createAsyncThunk(
  'surveys/updateSurveyStatus',
  async (surveyId, { rejectWithValue }) => {
    try {
      const response = await api.patch(`/v1/surveys/${surveyId}/status`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

// NEW SURVEY ACTIONS
export const createSurvey = createAsyncThunk(
  'surveys/createSurvey',
  async (surveyData, { rejectWithValue }) => {
    try {
      const response = await api.post('/v1/surveys', surveyData)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchSurveys = createAsyncThunk(
  'surveys/fetchSurveys',
  async (params = {}, { rejectWithValue }) => {
    try {
      const queryString = new URLSearchParams(params).toString()
      const url = `/v1/surveys${queryString ? `?${queryString}` : ''}`
      
      const response = await api.get(url)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchActiveSurvey = createAsyncThunk(
  'surveys/fetchActiveSurvey',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/surveys/active')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchSurveyRatingScales = createAsyncThunk(
  'surveys/fetchSurveyRatingScales',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/surveys/rating-scales')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchSurveyById = createAsyncThunk(
  'surveys/fetchSurveyById',
  async (surveyId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/v1/surveys/${surveyId}`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const updateSurvey = createAsyncThunk(
  'surveys/updateSurvey',
  async ({ surveyId, surveyData }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/v1/surveys/${surveyId}`, surveyData)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const deleteSurvey = createAsyncThunk(
  'surveys/deleteSurvey',
  async (surveyId, { rejectWithValue }) => {
    try {
      await api.delete(`/v1/surveys/${surveyId}`)
      return surveyId
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

// Survey Response Actions (existing)
export const fetchSurveyResponses = createAsyncThunk(
  'surveys/fetchSurveyResponses',
  async (surveyId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/v1/surveys/${surveyId}/responses`)
      return { surveyId, responses: response.data }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch survey responses'
      return rejectWithValue(errorMessage)
    }
  }
)

export const createSurveyResponse = createAsyncThunk(
  'surveys/createSurveyResponse',
  async ({ surveyId, responseData }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/v1/surveys/${surveyId}/responses`, responseData)
      return { surveyId, response: response.data }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to create survey response'
      return rejectWithValue(errorMessage)
    }
  }
)

export const fetchAllSurveyResponses = createAsyncThunk(
  'surveys/fetchAllSurveyResponses',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/survey-responses')
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch all survey responses'
      return rejectWithValue(errorMessage)
    }
  }
)

export const fetchTotalSurveyResponses = createAsyncThunk(
  'surveys/fetchTotalSurveyResponses',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/survey-responses/total')
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch total survey responses'
      return rejectWithValue(errorMessage)
    }
  }
)

export const fetchSurveyResponsesMoodScale = createAsyncThunk(
  'surveys/fetchSurveyResponsesMoodScale',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/survey-responses/mood-scale')
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch mood scale data'
      return rejectWithValue(errorMessage)
    }
  }
)